import type { Feature } from '@luna/gatekeeper';

export const limits: Feature = {
    enabled: true,
    _description:
        'Enables display of unified card limits on the bank card settings page, card features page and supplementary card settings page, currently used by HU and HR only.',
};
